import ProfitLossHTMLPreviewBaseSection from './ProfitLossHTMLPreviewBaseSection'

export default function ProfitLossHTMLPreviewGrandTotalSection() {}

ProfitLossHTMLPreviewGrandTotalSection.prototype = new ProfitLossHTMLPreviewBaseSection();

ProfitLossHTMLPreviewGrandTotalSection.prototype.init = function( columnsStrategy )
{
    ProfitLossHTMLPreviewBaseSection.prototype.init.call( this, columnsStrategy );
    return this;
};

ProfitLossHTMLPreviewGrandTotalSection.prototype.addRows = function( tBody )
{
    var splitterRow = this.createRow("splitterRow");
    this.addCell( splitterRow, "", "", this.columnsStrategy.getDataColumnsCount() + 1 );
    this.addRow( tBody, splitterRow );

    this.addRowWithMainCell( tBody, this.message("report.grand_total"), "grandTotalCell", "grandTotal" )
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/profitloss/ProfitLossHTMLPreviewGrandTotalSection.js